import {
  ActionContainer,
  BoardsNeedingPartContainer,
  Title,
} from "./InventoryUpdatesStyles";
import BoardNeedingPartDetails from "./BoardNeedingPartDetails";
import React from "react";
import useShipmentsThatNeedPart from "../../../../utils/hooks/inventory/shipmentsThatNeedPart";
import LoadingIcon from "../../../common/LoadingIcon";

export default function ProjectsUsingPart({
  containerBarcode,
}: {
  containerBarcode: string | null;
}) {
  const { shipmentsMissingPart } = useShipmentsThatNeedPart(
    null,
    containerBarcode,
  );

  if (shipmentsMissingPart === null) {
    return <LoadingIcon text={"Loading boards..."} />;
  }

  return (
    <BoardsNeedingPartContainer>
      <Title>Projects using part</Title>
      {shipmentsMissingPart.length > 0 ? (
        shipmentsMissingPart.map((allocationDetail) => (
          <ActionContainer key={allocationDetail.board.id}>
            <BoardNeedingPartDetails allocationDetail={allocationDetail} />
          </ActionContainer>
        ))
      ) : (
        <div style={{ textAlign: "center" }}>No projects</div>
      )}
    </BoardsNeedingPartContainer>
  );
}
